import styled from "@emotion/styled";

export const PaneContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 56px);
  justify-content: center;
`;
